export default function FinalCTA() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <div className="bg-gray-50 rounded-3xl p-8 md:p-16">
          <div className="w-20 h-20 bg-teal-600/10 rounded-2xl flex items-center justify-center mx-auto mb-8">
            <i className="ri-chat-check-line text-4xl text-teal-600"></i>
          </div>

          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Готовы увеличить конверсию телефонных продаж?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed mb-10">
            Давайте обсудим текущую ситуацию в вашем отделе продаж. Я прослушаю несколько звонков, дам обратную связь и предложу программу, адаптированную под ваши задачи.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => scrollTo('contact')}
              className="bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              Получить программу
              <i className="ri-arrow-right-line"></i>
            </button>
            <a
              href="https://t.me/a_sivko"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white text-teal-600 px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-50 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2 border-2 border-teal-600"
            >
              <i className="ri-telegram-line"></i>
              Telegram
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}